import { UntitledIcon } from '@faceup/icons'
import { ulChevronDown } from '@faceup/icons/ulChevronDown'
import { TreeSelect as AntTreeSelect, type TreeSelectProps as AntTreeSelectProps } from 'antd'

export type TreeSelectProps<T = string> = AntTreeSelectProps<T>

export const TreeSelect = <T,>({ suffixIcon, ...props }: TreeSelectProps<T>) => {
  return (
    <AntTreeSelect
      {...props}
      suffixIcon={suffixIcon ?? <UntitledIcon icon={ulChevronDown} size={20} color='#92B4DB' />}
    />
  )
}
